// @flow
import { put, takeEvery, call, all } from "redux-saga/effects";
import type { Saga, Effect } from "redux-saga";
import {
    GET_NATURE_TYPES,
    GET_NETWORK_TYPES,
    GET_STRUCTURE_TYPES,
    GET_REGIONS,
    GET_DEPARTMENTS,
    EVENT_DATA_LOADING,
    EVENT_DATA_SUCCESS,
    EVENT_DATA_ERROR,
} from "../actions/constants";
import MapAPI from "../api/MapAPI";

export function* getNatureTypes(): Saga<void> {
    const natureTypes = yield call(MapAPI.getNatureTypes);

    const data = natureTypes.data["hydra:member"].map(item => ({
        label: item.name,
        value: item["@id"],
    }));

    yield put({ type: GET_NATURE_TYPES, payload: data });
}

export function* watchGetNatureTypes(): Iterable<Effect> {
    while (true) {
        yield takeEvery(GET_NATURE_TYPES, getNatureTypes);
    }
}

export function* getNetworkTypes(): Saga<void> {
    const networkTypes = yield call(MapAPI.getNetworkTypes);

    const data = networkTypes.data["hydra:member"].map(item => ({
        label: item.name,
        value: item["@id"],
    }));

    yield put({ type: GET_NETWORK_TYPES, payload: data });
}

export function* watchGetNetworkTypes(): Iterable<Effect> {
    while (true) {
        yield takeEvery(GET_NETWORK_TYPES, getNetworkTypes);
    }
}

export function* getStructureTypes(): Saga<void> {
    const structureTypes = yield call(MapAPI.getStructureTypes);

    const data = structureTypes.data["hydra:member"].map(item => ({
        label: item.name,
        value: item["@id"],
    }));

    yield put({ type: GET_STRUCTURE_TYPES, payload: data });
}

export function* watchGetStructureTypes(): Iterable<Effect> {
    while (true) {
        yield takeEvery(GET_STRUCTURE_TYPES, getStructureTypes);
    }
}

export function* getRegions(): Saga<void> {
    const regions = yield call(MapAPI.getRegions);
    yield put({ type: GET_REGIONS, payload: regions.data["hydra:member"] });
}

export function* watchGetRegions(): Iterable<Effect> {
    yield takeEvery(GET_REGIONS, getRegions);
}

export function* getDepartments(): Saga<void> {
    const departments = yield call(MapAPI.getDepartments);

    const data = departments.data["hydra:member"].map(department => ({
        region_id: parseInt(department.region.replace("/api/regions/", ""), 10),
        ...department,
    }));

    yield put({
        type: GET_DEPARTMENTS,
        payload: data,
    });
}

export function* watchGetDepartments(): Iterable<Effect> {
    while (true) {
        yield takeEvery(GET_DEPARTMENTS, getDepartments);
    }
}

export function* watchGetDataAll(): Iterable<Effect> {
    while (true) {
        yield takeEvery(EVENT_DATA_SUCCESS, getDepartments);
    }
}

export function* getDataAll(): Saga<void> {
    try {
        // $FlowFixMe
        yield all([
            getNatureTypes(),
            getNetworkTypes(),
            getStructureTypes(),
            getRegions(),
            getDepartments(),
        ]);
        yield put({ type: EVENT_DATA_LOADING, payload: { loading: false } });
        yield put({ type: EVENT_DATA_SUCCESS });
    } catch {
        yield put({ type: EVENT_DATA_ERROR, payload: { error: true } });
        yield put({ type: EVENT_DATA_LOADING, payload: { loading: false } });
    }
}

export default function* getData(): Saga<void> {
    // $FlowFixMe
    yield all([getDataAll()]);
}
